import { ActionTree } from "vuex";
import { SpinState } from "./state";
import { MODULES, vuexName } from "../utils";

const actions: ActionTree<SpinState, any> = {
  // Use in gl-common
  setMaskMain(store, value: boolean) {
    store.commit(vuexName(MODULES.SPIN.COMMITS.SET_MASK_MAIN, false), value);
  },
};

export default actions;
